module.exports = __webpack_public_path__ + "static/media/engine-guard.1d7e33ed.jpg";